import { AddIcon } from '@approvalmax/ui';
import { Button, Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { usePermissions } from 'shared/hooks/usePermissions';

import { messages } from './Header.messages';
import { HeaderProps } from './Header.types';

export const Header = memo<HeaderProps>((props) => {
    const { title, externalUrl, onAddPaymentDetails } = props;

    const company = useCompanyBasedOnUrl();

    const { isPaymentDetailsAddEnabled } = usePermissions(company);

    return (
        <Flex alignItems='center' justifyContent='space-between'>
            <Text font='headline' fontSize='small'>
                {title}
            </Text>

            <Flex alignItems='center' spacing='16'>
                {externalUrl && (
                    <Button
                        as='a'
                        href={externalUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        size='small'
                        variant='text'
                        color='blue100'
                    >
                        {messages.openInXero}
                    </Button>
                )}

                {/* will be added later
                <Button color='blue80' size='small' outline startIcon={<ReloadIcon />}>
                    {messages.sync}
                </Button>
                */}

                {isPaymentDetailsAddEnabled && (
                    <Button color='blue80' size='small' startIcon={<AddIcon />} onClick={onAddPaymentDetails}>
                        {messages.addPaymentDetails}
                    </Button>
                )}
            </Flex>
        </Flex>
    );
});

Header.displayName = 'Header';
